

























import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({})
export default class PMenu extends Vue {
  @Prop({}) public list!: [];
  @Prop({}) public defaultActive!: string;

  private active = -1;
  private hoverActive: any = null;
  private created() {
    // console.log(this.list, this.defaultActive);
    this.active = this.list.findIndex((i: any) => i.url === this.defaultActive);
    // console.log(this.list, this.defaultActive);
  }
  get isList() {
    return (value: any) => {
      // console.log(value);
      if ((value.id === 400 && this.defaultActive === '/voting/list.html') || (value.id === 900 && this.defaultActive === '/questionnaire/exam.html') || (value.id === 300 && this.defaultActive === '/questionnaire/list.html') || (value.id === 1000 && this.defaultActive === '/questionnaire/form.html') || (value.id === 1400 && this.defaultActive === '/questionnaire/solitaire.html') || (value.id === 1500 && this.defaultActive === '/questionnaire/online.html')) {
        return true;
      } else {
        return false;
      }
    };
  }
  private handleAction(val: any, index: number) {
    // console.log(val);
    this.active = index;
    this.$emit('select', val.url);
  }
}
